import { auth } from '@/lib/firebase'
import {
  COMMUNITY_COMMENTS_ENDPOINT,
  COMMUNITY_COMMENTS_QUERY_ENDPOINT,
  COMMUNITY_COMMENTS_VOTE_DIRECTIONS_ENDPOINT,
  COMMUNITY_COMMENTS_VOTE_ENDPOINT,
  COMMUNITY_POSTS_ENDPOINT,
  COMMUNITY_POSTS_VOTE_DIRECTIONS_ENDPOINT,
  COMMUNITY_POSTS_VOTE_ENDPOINT,
  QUERY_COMMUNITY_POSTS_ENDPOINT,
} from '@/config/endpoints'

async function buildCommunityRequestHeaders(requireAuth = false): Promise<HeadersInit> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  const currentUser = auth.currentUser
  if (currentUser) {
    headers.Authorization = `Bearer ${await currentUser.getIdToken()}`
  } else if (requireAuth) {
    throw new Error('Authentication required')
  }

  return headers
}

export async function communityApiPost<TResponse>(
  endpoint: string,
  body: unknown,
  requireAuth = false,
): Promise<TResponse> {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: await buildCommunityRequestHeaders(requireAuth),
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}))
    const detail = typeof errorBody.detail === 'string' ? errorBody.detail : response.statusText
    throw new Error(detail || 'Community API request failed')
  }

  return response.json() as Promise<TResponse>
}

export async function communityApiGet<TResponse>(endpoint: string): Promise<TResponse> {
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: await buildCommunityRequestHeaders(false),
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}))
    const detail = typeof errorBody.detail === 'string' ? errorBody.detail : response.statusText
    throw new Error(detail || 'Community API request failed')
  }

  return response.json() as Promise<TResponse>
}

export const communityApiEndpoints = {
  queryPosts: QUERY_COMMUNITY_POSTS_ENDPOINT,
  post: COMMUNITY_POSTS_ENDPOINT,
  postVote: COMMUNITY_POSTS_VOTE_ENDPOINT,
  postVoteDirections: COMMUNITY_POSTS_VOTE_DIRECTIONS_ENDPOINT,
  commentsQuery: COMMUNITY_COMMENTS_QUERY_ENDPOINT,
  comments: COMMUNITY_COMMENTS_ENDPOINT,
  commentVote: COMMUNITY_COMMENTS_VOTE_ENDPOINT,
  commentVoteDirections: COMMUNITY_COMMENTS_VOTE_DIRECTIONS_ENDPOINT,
}
